import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["data-testid"];
const _hoisted_2 = { class: "text-sm font-semibold text-(--colors-text-heading)" };
import { SelectInput, TextInput } from "@eudonet/opal";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { taxReceiptEmailSubjectError, TAX_RECEIPT_EMAIL_SUBJECT_MAX_LENGTH, } from "../../../domain/entities/taxReceiptEmailContexts";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DonationSettingsEmailContextCard',
    props: {
        context: {},
        value: {},
        templateOptions: {},
        defaultTemplateMissing: { type: Boolean },
        showRequiredError: { type: Boolean },
        testId: {}
    },
    emits: ["update:defaultTemplate", "update:subject"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { t } = useI18n();
        const subjectErrorKey = computed(() => {
            const error = taxReceiptEmailSubjectError(props.value.subject);
            if (error === "unknownVariable")
                return "finance.taxReceipts.settings.errors.emailSubjectUnknownVariable";
            if (error === "malformedVariable")
                return "finance.taxReceipts.settings.errors.emailSubjectMalformedVariable";
            return error ? "finance.taxReceipts.settings.errors.emailSubject" : null;
        });
        const defaultTemplateOptions = computed(() => [
            { value: "", label: t("finance.taxReceipts.settings.emailTemplates.noDefaultOption") },
            ...props.templateOptions,
        ]);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "flex flex-col gap-4 rounded-lg border border-(--colors-border-base-soft) p-4",
                "data-testid": __props.testId
            }, [
                _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t(`finance.taxReceipts.settings.emailTemplates.contexts.${__props.context}`)), 1 /* TEXT */),
                _createVNode(_unref(TextInput), {
                    "model-value": __props.value.subject,
                    label: _ctx.$t('finance.taxReceipts.settings.emailTemplates.subjectLabel'),
                    hint: _ctx.$t('finance.taxReceipts.settings.emailTemplates.subjectHint'),
                    maxlength: _unref(TAX_RECEIPT_EMAIL_SUBJECT_MAX_LENGTH),
                    error: __props.showRequiredError && subjectErrorKey.value ? _ctx.$t(subjectErrorKey.value) : undefined,
                    required: "",
                    autocomplete: "off",
                    "full-width": "",
                    "data-testid": `${__props.testId}-subject`,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (emit('update:subject', $event)))
                }, null, 8 /* PROPS */, ["model-value", "label", "hint", "maxlength", "error", "data-testid"]),
                _createVNode(_unref(SelectInput), {
                    "model-value": __props.value.defaultTemplateId ?? '',
                    options: defaultTemplateOptions.value,
                    label: _ctx.$t('finance.taxReceipts.settings.emailTemplates.defaultTemplateLabel'),
                    hint: __props.defaultTemplateMissing ? _ctx.$t('finance.taxReceipts.settings.emailTemplates.defaultTemplateMissing') : undefined,
                    error: __props.showRequiredError && __props.defaultTemplateMissing ? _ctx.$t('finance.donationModuleSettings.errors.required') : undefined,
                    required: "",
                    "full-width": "",
                    "data-testid": `${__props.testId}-default`,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (emit('update:defaultTemplate', $event || null)))
                }, null, 8 /* PROPS */, ["model-value", "options", "label", "hint", "error", "data-testid"])
            ], 8 /* PROPS */, _hoisted_1));
        };
    }
});
